(() => {
  const inputMode = mode => { document.documentElement.dataset.sfInput = mode; };
  document.addEventListener('pointerdown', () => inputMode('pointer'), true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab' || event.key.startsWith('Arrow') || event.key === 'Enter' || event.key === ' ') inputMode('keyboard');
  }, true);
  const root = () => window.Shopify?.routes?.root || '/';
  const scrollMetrics = () => {
    const area = document.querySelector('.page-wrapper');
    if (area && area.scrollHeight > area.clientHeight && /auto|scroll/.test(getComputedStyle(area).overflowY)) {
      return {top:area.scrollTop, range:area.scrollHeight - area.clientHeight};
    }
    return {top:window.scrollY, range:document.documentElement.scrollHeight - window.innerHeight};
  };
  const setupReveals = () => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('sf-revealed');
      observer.unobserve(entry.target);
    }), {rootMargin:'0px 0px 100px 0px',threshold:0});
    document.querySelectorAll('.sf-book,.sf-manifesto,.sf-social,.sf-faq,.sf-brands,.sf-reading,.sf-readers,.sf-video-section').forEach(section => {
      if (section.dataset.sfRevealReady || section.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      section.dataset.sfRevealReady = 'true';
      section.classList.add('sf-reveal');
      observer.observe(section);
    });
  };
  const setupAnnouncements = () => {
    const bar = document.querySelector('[data-sf-announcements]');
    if (!bar || bar.dataset.sfReady) return;
    bar.dataset.sfReady = 'true';
    const messages = Array.from(bar.querySelectorAll('.sf-announcement-message'));
    const control = bar.querySelector('[data-sf-announcement-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = Math.max(0, messages.findIndex(message => !message.hidden));
    let paused = false, hovering = false, timer;
    const updateControl = () => {
      if (!control) return;
      control.setAttribute('aria-pressed', String(paused));
      control.setAttribute('aria-label', paused ? control.dataset.playLabel : control.dataset.pauseLabel);
      control.innerHTML = `<svg class="sf-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paused ? '<path d="m9 5 11 7-11 7V5Z"/>' : '<path d="M8 5v14M16 5v14"/>'}</svg>`;
    };
    const schedule = () => {
      clearTimeout(timer);
      if (bar.isConnected && messages.length > 1) timer = setTimeout(next, Number(messages[index].dataset.duration) || 3200);
    };
    const next = () => {
      if (!bar.isConnected) return;
      if (paused || document.hidden) { schedule(); return; }
      const current = messages[index];
      current.classList.add('sf-message-out');
      setTimeout(() => {
        if (!bar.isConnected) return;
        current.hidden = true;
        current.classList.remove('sf-message-out', 'is-current');
        index = (index + 1) % messages.length;
        const incoming = messages[index];
        incoming.hidden = false;
        incoming.classList.add('sf-message-in');
        requestAnimationFrame(() => requestAnimationFrame(() => { incoming.classList.remove('sf-message-in'); incoming.classList.add('is-current'); }));
        schedule();
      }, reduced ? 0 : 260);
    };
    control?.addEventListener('click', () => { paused = !paused; updateControl(); schedule(); });
    
    updateControl(); schedule();
  };
  const setupCartPanel = () => {
    const dialog=document.querySelector('[data-sf-cart-dialog]');
    if(!dialog||dialog.dataset.sfReady||typeof dialog.showModal!=='function')return;
    dialog.dataset.sfReady='true';
    let busy=false;
    const singleBookHandle='warum-sich-nichts-verandert-vom-overthinking-ins-handeln-aber-wohin-eigentlich';
    const readCart=async()=>{
      const response=await fetch(root()+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('cart unavailable');
      return response.json();
    };
    const normalizeBook=async()=>{
      let cart=await readCart();
      const copies=cart.items.filter(item=>item.handle===singleBookHandle);
      const updates={};
      copies.forEach((item,index)=>{const quantity=index===0?1:0;if(item.quantity!==quantity)updates[item.key]=quantity;});
      const changed=Object.keys(updates).length>0;
      if(changed){
        const response=await fetch(root()+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
        if(!response.ok)throw new Error('cart update');
        cart=await response.json();
      }
      return {cart,changed};
    };
    const status=message=>{const node=dialog.querySelector('[data-sf-cart-status]');if(node)node.textContent=message;};
    const text=key=>dialog.dataset[key]||'';
    const formField=(form,selector)=>Array.from(form.elements).find(field=>field.matches?.(selector));
    let closeMotion;
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const close=()=>{
      if(!dialog.open||closeMotion)return;
      if(reducedMotion||typeof dialog.animate!=='function'){dialog.close();return;}
      dialog.classList.add('sf-cart-closing');
      closeMotion=dialog.animate([{transform:'translateX(0)'},{transform:'translateX(105%)'}],{duration:240,easing:'cubic-bezier(.4,0,1,1)'});
      closeMotion.onfinish=()=>{closeMotion=null;dialog.classList.remove('sf-cart-closing');dialog.close();};
    };
    dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
    dialog.addEventListener('close',()=>document.body.classList.remove('sf-modal-open'));
    document.addEventListener('invalid',event=>{
      if(!event.target.matches?.('[data-sf-digital-consent]'))return;
      event.target.setCustomValidity('Bitte bestätige die Zustimmung, um fortzufahren.');
      if(dialog.contains(event.target))event.target.scrollIntoView({block:'center'});
    },true);
    document.addEventListener('change',event=>{
      if(event.target.matches?.('[data-sf-digital-consent]'))event.target.setCustomValidity('');
    },true);
    const show=()=>{
      if(closeMotion){closeMotion.cancel();closeMotion=null;dialog.classList.remove('sf-cart-closing');}
      if(!dialog.open){dialog.showModal();if(!reducedMotion&&typeof dialog.animate==='function')dialog.animate([{transform:'translateX(105%)'},{transform:'translateX(0)'}],{duration:300,easing:'cubic-bezier(.2,.65,.3,1)'});}
      document.body.classList.add('sf-modal-open');
    };
    const refresh=async()=>{
      const response=await fetch(`${root()}?section_id=sherif-cart-panel`,{credentials:'same-origin',headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error('cart render');
      const html=await response.text();const doc=new DOMParser().parseFromString(html,'text/html');const fresh=doc.querySelector('.sf-cart-panel');
      if(!fresh)throw new Error('cart unavailable');
      dialog.querySelector('.sf-cart-panel').innerHTML=fresh.innerHTML;
      const count=dialog.querySelector('[data-sf-panel-count]')?.textContent||'0';document.querySelectorAll('.sf-cart-count').forEach(node=>{node.textContent=count;});
    };
    const change=async(key,quantity)=>{
      if(busy)return;busy=true;dialog.setAttribute('aria-busy','true');
      try{const response=await fetch(`${root()}cart/change.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});const data=await response.json();if(!response.ok)throw new Error(data.description||'cart');await refresh();}
      catch{status(text('error'));}
      finally{busy=false;dialog.removeAttribute('aria-busy');}
    };
    document.querySelectorAll('[data-sf-cart-open]').forEach(link=>{if(link.dataset.sfReady)return;link.dataset.sfReady='true';link.addEventListener('click',async event=>{event.preventDefault();show();status(text('loading'));try{await normalizeBook();await refresh();}catch{status(text('error'));}});});
    dialog.addEventListener('click',event=>{
      if(event.target===dialog||event.target.closest('[data-sf-cart-close]'))close();
      const browse=event.target.closest('[data-sf-cart-browse]');if(browse)close();
      const step=event.target.closest('[data-sf-quantity-step]');
      if(step){event.preventDefault();change(step.dataset.lineKey,Math.max(0,Number(step.dataset.quantity)+Number(step.dataset.sfQuantityStep)));}
      const remove=event.target.closest('[data-sf-cart-remove]');if(remove){event.preventDefault();change(remove.dataset.lineKey,0);}
    });
    dialog.addEventListener('change',event=>{const input=event.target.closest('[data-sf-cart-quantity]');if(!input)return;const quantity=Number(input.value);if(!Number.isInteger(quantity)||quantity<0)return;change(input.dataset.lineKey,quantity);});
    const isAddForm=form=>form instanceof HTMLFormElement && (form.hasAttribute('data-sf-cart-add') || ['sf-product-form','sf-sticky-product-form'].includes(form.getAttribute('id')));
    const submit=async form=>{
      if(busy)return;busy=true;
      const panelUpdate=form.getAttribute('id')==='sf-panel-cart-form';
      const button=form.querySelector('button[type="submit"]');const wasDisabled=button?.disabled;if(button)button.disabled=true;
      try{
        const singleCopy=form.dataset.sfSingleCopy === 'true';
        const existing=singleCopy?await normalizeBook():null;
        const alreadyAdded=existing?.cart.items.some(item=>item.handle===singleBookHandle);
        if(!alreadyAdded){
          const url=panelUpdate?'cart/update.js':'cart/add.js';
          const payload=new FormData(form);
          if(singleCopy)payload.set('quantity','1');
          const response=await fetch(root()+url,{method:'POST',credentials:'same-origin',body:payload,headers:{Accept:'application/json'}});
          const data=await response.json();
          if(!response.ok)throw new Error(data.description||'cart');
          if(singleCopy)await normalizeBook();
        }
        show();status(text('loading'));await refresh();
        if(!panelUpdate)status(text(alreadyAdded?'alreadyAdded':'added'));
      }catch{show();status(text('error'));}
      finally{busy=false;if(button?.isConnected)button.disabled=wasDisabled;}
    };
    if(document.querySelector('[data-sf-cart-page-form]')){
      normalizeBook().then(result=>{if(result.changed)window.location.reload();}).catch(()=>{});
      document.addEventListener('click',async event=>{
        const step=event.target.closest?.('[data-sf-quantity-step]');
        if(!step||dialog.contains(step)||busy)return;
        event.preventDefault();busy=true;step.disabled=true;
        try{
          const response=await fetch(root()+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:step.dataset.lineKey,quantity:Math.max(0,Number(step.dataset.quantity)+Number(step.dataset.sfQuantityStep))})});
          if(!response.ok)throw new Error('cart update');
          window.location.reload();
        }catch{busy=false;step.disabled=false;show();status(text('error'));}
      });
    }
    window.addEventListener('submit',async event=>{
      const form=event.target;
      if(!(form instanceof HTMLFormElement)||event.submitter?.name!=='checkout'||form.dataset.sfCheckoutReady)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(busy)return;
      const originalConsent=formField(form,'[data-sf-digital-consent]');
      if(originalConsent&&!originalConsent.checked){originalConsent.reportValidity();return;}
      const consentGiven=Boolean(originalConsent?.checked);
      busy=true;
      try{
        const result=await normalizeBook();
        if(result.cart.item_count===0){await refresh();show();return;}
        if(result.cart.items.some(item=>item.handle===singleBookHandle)&&!consentGiven){
          if(form.hasAttribute('data-sf-cart-page-form'))window.location.reload();
          else{await refresh();show();status('Bitte bestätige die Bereitstellung des E-Books, bevor du zur Kasse gehst.');}
          return;
        }
        if(result.changed){if(form.hasAttribute('data-sf-cart-page-form')){window.location.reload();return;}await refresh();}
        const checkoutForm=form.isConnected?form:dialog.querySelector('.sf-panel-footer form');
        if(!checkoutForm)throw new Error('checkout unavailable');
        const activeConsent=formField(checkoutForm,'[data-sf-digital-consent]');
        if(activeConsent && consentGiven)activeConsent.checked=true;
        const consentTime=formField(checkoutForm,'[data-sf-consent-time]');
        if(consentTime && activeConsent?.checked)consentTime.value=new Date().toISOString();
        checkoutForm.dataset.sfCheckoutReady='true';
        const button=checkoutForm.querySelector('[name="checkout"]');
        checkoutForm.requestSubmit(button);
      }catch{show();status(text('error'));}
      finally{busy=false;}
    },true);
    const directForm=document.querySelector('[data-sf-direct-purchase]');
    const directButton=directForm?.querySelector('button[type="submit"]');
    if(directButton)directButton.disabled=false;
    window.addEventListener('submit',async event=>{
      const form=event.target;
      if(!(form instanceof HTMLFormElement)||!form.matches('[data-sf-direct-purchase]'))return;
      event.preventDefault();event.stopImmediatePropagation();
      if(busy||!form.reportValidity())return;
      const consent=form.querySelector('[data-sf-digital-consent]');
      const button=form.querySelector('button[type="submit"]');
      const error=form.querySelector('[data-sf-direct-error]');
      if(!consent?.checked)return;
      busy=true;if(button)button.disabled=true;if(error)error.hidden=true;
      try{
        const result=await normalizeBook();
        if(!result.cart.items.some(item=>item.handle===singleBookHandle)){
          const response=await fetch(root()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(form.dataset.variantId),quantity:1}]})});
          if(!response.ok)throw new Error('could not add book');
        }
        const attributes={...(result.cart.attributes||{})};
        attributes['Einverständnis digitale Inhalte']=consent.value;
        attributes['Zeitpunkt Einverständnis UTC']=new Date().toISOString();
        const saved=await fetch(root()+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes})});
        if(!saved.ok)throw new Error('could not save consent');
        const savedCart=await saved.json();
        if(savedCart.attributes?.['Einverständnis digitale Inhalte']!==consent.value || savedCart.attributes?.['Zeitpunkt Einverständnis UTC']!==attributes['Zeitpunkt Einverständnis UTC'])throw new Error('consent not persisted');
        window.location.assign(root()+'checkout?locale=de');
      }catch{if(error){error.hidden=false;error.scrollIntoView({block:'nearest'});}}
      finally{busy=false;if(button?.isConnected)button.disabled=false;}
    },true);
    window.addEventListener('submit',event=>{
      const form=event.target;
      if(!isAddForm(form)&&form.getAttribute?.('id')!=='sf-panel-cart-form')return;
      event.preventDefault();event.stopImmediatePropagation();submit(form);
    },true);
    window.addEventListener('click',event=>{
      const button=event.target.closest?.('button,input[type="submit"]');
      if(!button||button.type!=='submit'||!isAddForm(button.form))return;
      event.preventDefault();event.stopImmediatePropagation();
      if(!button.disabled&&button.form.reportValidity())submit(button.form);
    },true);
  };
  const setupPrivacyAppearance = () => {
    const labelsNode = document.getElementById('sf-cookie-labels');
    const dialog = document.querySelector('[data-sf-cookie-dialog]');
    if (!labelsNode || !dialog || dialog.dataset.sfReady) return;
    dialog.dataset.sfReady = 'true';
    const labels = JSON.parse(labelsNode.textContent);
    const form = dialog.querySelector('form');
    const status = dialog.querySelector('[data-sf-cookie-status]');
    let apiPromise;
    const api = () => {
      if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
      if (!apiPromise) apiPromise = new Promise((resolve, reject) => {
        if (!window.Shopify?.loadFeatures) { reject(new Error('privacy unavailable')); return; }
        const timeout = setTimeout(() => reject(new Error('privacy timeout')), 8000);
        window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => {
          clearTimeout(timeout);
          if (error || !window.Shopify.customerPrivacy) reject(new Error('privacy unavailable'));
          else resolve(window.Shopify.customerPrivacy);
        });
      }).catch(error => { apiPromise = undefined; throw error; });
      return apiPromise;
    };
    const applyLabels = () => {
      const text = (id, value) => { const node = document.getElementById(id); if (node && node.textContent !== value) node.textContent = value; };
      text('shopify-pc__banner__body-title', labels.title);
      text('shopify-pc__banner__btn-accept', labels.accept);
      text('shopify-pc__banner__btn-decline', labels.reject);
      text('shopify-pc__banner__btn-manage-prefs', 'Cookie-Einstellungen');
      const body = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
      const policy = document.getElementById('shopify-pc__banner__body-policy-link');
      if (body && policy && !body.dataset.sfTranslated) {
        const link = policy.cloneNode(true);
        link.textContent = labels.privacy;
        if (labels.privacyUrl) link.setAttribute('href', labels.privacyUrl);
        body.replaceChildren(document.createTextNode(labels.copy + ' '), link);
        body.dataset.sfTranslated = 'true';
      }
    };
    applyLabels();
    const observer = new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.id?.startsWith('shopify-pc__') || node.querySelector?.('#shopify-pc__banner'))))) applyLabels();
    });
    observer.observe(document.body, {childList:true,subtree:true});
    const open = async () => {
      const footerStatus = document.querySelector('[data-sf-privacy-status]');
      try {
        const privacy = await api();
        const current = privacy.currentVisitorConsent();
        ['preferences','analytics','marketing'].forEach(key => { form.elements[key].checked = current[key] === 'yes'; });
        status.textContent = '';
        if (footerStatus) footerStatus.textContent = '';
        if (!dialog.open) dialog.showModal();
        document.body.classList.add('sf-modal-open');
      } catch { if (footerStatus) footerStatus.textContent = labels.error; }
    };
    document.querySelectorAll('[data-sf-privacy-open]').forEach(button => button.addEventListener('click', open));
    // Keep Shopify's accept/decline handlers. Only its preferences button opens
    // the equivalent German interface; saved choices use the same Shopify API.
    document.addEventListener('click', event => {
      if (event.target.closest?.('#shopify-pc__banner__btn-manage-prefs')) { event.preventDefault(); event.stopImmediatePropagation(); open(); }
    }, true);
    const close = () => dialog.close();
    dialog.querySelector('[data-sf-cookie-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.body.classList.remove('sf-modal-open'); });
    let busy = false;
    const save = async consent => {
      if (busy) return;
      busy = true; form.setAttribute('aria-busy', 'true'); status.textContent = '';
      try {
        const privacy = await api();
        await new Promise((resolve, reject) => {
          const timeout = setTimeout(() => reject(new Error('consent timeout')), 8000);
          privacy.setTrackingConsent(consent, () => {
            clearTimeout(timeout);
            const current = privacy.currentVisitorConsent();
            if (Object.entries(consent).every(([key, value]) => current[key] === (value ? 'yes' : 'no'))) resolve();
            else reject(new Error('consent not persisted'));
          });
        });
        const footerStatus = document.querySelector('[data-sf-privacy-status]');
        if (footerStatus) footerStatus.textContent = labels.saved;
        close();
      } catch { status.textContent = labels.error; }
      finally { busy = false; form.removeAttribute('aria-busy'); }
    };
    form.addEventListener('submit', event => { event.preventDefault(); save({preferences:form.elements.preferences.checked,analytics:form.elements.analytics.checked,marketing:form.elements.marketing.checked}); });
    dialog.querySelectorAll('[data-sf-cookie-choice]').forEach(button => button.addEventListener('click', () => { const accept = button.dataset.sfCookieChoice === 'accept'; save({preferences:accept,analytics:accept,marketing:accept}); }));
  };
  // Keep draft form choices in this document only, including a replaced theme section.
  const newsletterDrafts = new Map();
  const newsletterForms = new WeakSet();
  let newsletterWatcher;
  const setupNewsletterForms = () => {
    if (document.querySelector('[data-sf-newsletter-success]')) {
      try { localStorage.setItem('sf-newsletter-requested-v1', 'true'); } catch {}
    }
    document.querySelectorAll('[data-sf-subscription]').forEach(form => {
      if (newsletterForms.has(form)) return;
      newsletterForms.add(form);
      const key = form.id;
      const email = form.querySelector('input[type=email]');
      const consent = form.querySelector('input[type=checkbox]');
      const draft = newsletterDrafts.get(key);
      if (draft) {
        if (email) email.value = draft.email;
        if (consent) consent.checked = draft.checked;
        form.dataset.sfInteracted = 'true';
      }
      const remember = () => {
        newsletterDrafts.set(key, {email:email?.value || '', checked:Boolean(consent?.checked)});
        form.dataset.sfInteracted = 'true';
      };
      form.addEventListener('input', remember);
      form.addEventListener('change', remember);
      form.addEventListener('focusin', () => { form.dataset.sfInteracted = 'true'; });
      form.addEventListener('reset', () => {
        const saved = newsletterDrafts.get(key);
        if (!saved) return;
        requestAnimationFrame(() => {
          if (email) email.value = saved.email;
          if (consent) consent.checked = saved.checked;
        });
      });
      form.querySelectorAll('[data-sf-validation]').forEach(input => {
        input.addEventListener('invalid', () => input.setCustomValidity(input.dataset.sfValidation));
        input.addEventListener('input', () => input.setCustomValidity(''));
        input.addEventListener('change', () => input.setCustomValidity(''));
        if (input.type === 'email') input.addEventListener('blur', () => { input.value = input.value.trim(); remember(); });
      });
      form.addEventListener('submit', event => {
        if (email) email.value = email.value.trim();
        remember();
        if (!form.reportValidity() || form.dataset.sfSubmitting) { event.preventDefault(); return; }
        form.dataset.sfSubmitting = 'true';
        const button = form.querySelector('button[type=submit]');
        if (button) {
          button.classList.add('sf-just-tapped');
          setTimeout(() => button.classList.remove('sf-just-tapped'), 180);
        }
      });
      window.addEventListener('pageshow', () => {
        delete form.dataset.sfSubmitting;
        const button = form.querySelector('button[type=submit]');
        if (button) {
          if (button.dataset.sfIdleLabel) button.textContent = button.dataset.sfIdleLabel;
          button.disabled = false;
        }
      });
    });
    if (!newsletterWatcher) {
      newsletterWatcher = new MutationObserver(records => {
        if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-sf-subscription]') || node.querySelector('[data-sf-subscription]'))))) setupNewsletterForms();
      });
      newsletterWatcher.observe(document.body, {childList:true, subtree:true});
    }
  };
  const setupReviews = () => {
    document.querySelectorAll('[data-sf-reviews]').forEach(section => {
      if (section.dataset.sfReviewLayout === 'editorial') return;
      if (section.dataset.sfReviewsReady) return;
      const track = section.querySelector('[data-sf-review-track]');
      const controls = section.querySelector('[data-sf-review-controls]');
      if (!track || !controls) return;
      section.dataset.sfReviewsReady = 'true';
      const originals = Array.from(track.querySelectorAll('[data-sf-review-card]'));
      const base = originals.filter(card => !card.hasAttribute('data-sf-review-extra'));
      const dots = Array.from(section.querySelectorAll('[data-sf-review-dot]'));
      const dotGroup = section.querySelector('[data-sf-review-dots]');
      const more = section.querySelector('[data-sf-review-more]');
      const counter = section.querySelector('[data-sf-review-counter]');
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      let start = 0, span = 0, step = 0, frame, settleTimer, drag, rebuilding = false, lastWidth = 0;
      const expanded = () => section.classList.contains('sf-reviews-expanded');
      const coordinate = card => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      const modulo = value => ((value % base.length) + base.length) % base.length;
      const mark = () => {
        if (!step || !base.length || expanded()) return;
        const index = modulo(Math.round((track.scrollLeft - start) / step));
        if (counter) counter.textContent = `${index + 1} / ${base.length}`;
        dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
      };
      const normalize = () => {
        if (!span || rebuilding || drag || expanded()) return;
        const left = track.scrollLeft;
        if (left < start - step * .55) track.scrollTo({left:left + span,behavior:'instant'});
        else if (left > start + span - step * .45) track.scrollTo({left:left - span,behavior:'instant'});
        mark();
      };
      const rebuild = () => {
        rebuilding = true;
        clearTimeout(settleTimer);
        track.querySelectorAll('[data-sf-review-clone]').forEach(card => card.remove());
        if (expanded() || base.length < 2 || !track.clientWidth) {
          span = 0; step = 0; track.scrollTo({left:0,behavior:'instant'}); rebuilding = false; return;
        }
        const clone = card => {
          const node = card.cloneNode(true);
          node.setAttribute('data-sf-review-clone','');
          node.setAttribute('aria-hidden','true');
          node.setAttribute('inert','');
          node.removeAttribute('data-sf-review-card');
          return node;
        };
        const before = document.createDocumentFragment(), after = document.createDocumentFragment();
        base.forEach(card => { before.append(clone(card)); after.append(clone(card)); });
        track.prepend(before); track.append(after);
        start = coordinate(base[0]);
        step = coordinate(base[1]) - start;
        span = step * base.length;
        track.scrollTo({left:start,behavior:'instant'});
        rebuilding = false; mark();
      };
      const move = direction => {
        if (!step || expanded()) return;
        track.scrollTo({left:track.scrollLeft + direction * step,behavior});
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => track.scrollTo({left:start + index * step,behavior})));
      track.addEventListener('keydown', event => {
        if (expanded() || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') track.scrollTo({left:start + (event.key === 'End' ? base.length - 1 : 0) * step,behavior});
        else move(event.key === 'ArrowRight' ? 1 : -1);
      });
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame); frame = requestAnimationFrame(mark);
        clearTimeout(settleTimer); settleTimer = setTimeout(normalize,180);
      }, {passive:true});
      track.addEventListener('scrollend', normalize);
      track.addEventListener('pointerdown', event => {
        if (expanded() || event.pointerType !== 'mouse' || event.button !== 0 || base.length < 2) return;
        drag = {id:event.pointerId,x:event.clientX,left:track.scrollLeft,moved:false};
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const delta = event.clientX - drag.x;
        if (Math.abs(delta) < 6 && !drag.moved) return;
        event.preventDefault(); drag.moved = true;
        track.dataset.sfReviewDragging = 'true'; track.scrollLeft = drag.left - delta;
      });
      const endDrag = () => {
        if (!drag) return;
        const moved = drag.moved; drag = undefined;
        delete track.dataset.sfReviewDragging;
        if (moved && step) track.scrollTo({left:start + Math.round((track.scrollLeft - start) / step) * step,behavior});
        settleTimer = setTimeout(normalize,200);
      };
      track.addEventListener('pointerup',endDrag);
      track.addEventListener('pointercancel',endDrag);
      track.addEventListener('lostpointercapture',endDrag);
      more?.addEventListener('click', () => {
        const open = section.classList.toggle('sf-reviews-expanded');
        more.setAttribute('aria-expanded',String(open)); more.textContent = open ? more.dataset.lessLabel : more.dataset.moreLabel;
        if (dotGroup) dotGroup.hidden = open;
        if (counter) counter.hidden = open;
        rebuild();
      });
      if (dotGroup) dotGroup.hidden = base.length < 2;
      controls.hidden = base.length < 2 && !more;
      const observer = new ResizeObserver(() => {
        if (Math.abs(lastWidth - track.clientWidth) < 1) return;
        lastWidth = track.clientWidth; rebuild();
      });
      section.sfReviewsCleanup = () => { observer.disconnect(); clearTimeout(settleTimer); cancelAnimationFrame(frame); };
      observer.observe(track);
      document.addEventListener('shopify:section:unload', () => { if (!section.isConnected) { observer.disconnect(); clearTimeout(settleTimer); cancelAnimationFrame(frame); } }, {once:true});
      lastWidth = track.clientWidth; rebuild();
    });
  };
  document.addEventListener('sf:reviews-updated', setupReviews);
  const setupDigitalpost = () => {
    const section = document.querySelector('[data-sf-newsletter-section]');
    if (!section || section.dataset.sfReady) return;
    section.dataset.sfReady = 'true';
    const dialog = document.querySelector('[data-sf-newsletter]');
    const storage = {
      get: key => { try { return localStorage.getItem(key); } catch { return null; } },
      set: (key, value) => { try { localStorage.setItem(key, value); } catch { /* Private browsing: still respect the current page. */ } }
    };
    const requestedKey = 'sf-newsletter-requested-v1';
    const dismissedKey = 'sf-newsletter-closed-until-v1';
    const success = section.querySelector('[data-sf-newsletter-success]') || dialog?.querySelector('[data-sf-newsletter-success]');
    if (success) storage.set(requestedKey, 'true');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let shown = false;
    const close = () => {
      storage.set(dismissedKey, String(Date.now() + 14 * 86400000));
      dialog.close();
    };
    const open = () => {
      if (!dialog.open) { dialog.showModal(); shown = true; document.body.classList.add('sf-modal-open'); }
    };
    dialog.querySelectorAll('[data-sf-newsletter-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.body.classList.remove('sf-modal-open'); });
    if (dialog.querySelector('[data-sf-newsletter-success], .sf-form-errors')) open();
    const suppressed = () => shown || Boolean(document.querySelector('[data-sf-subscription][data-sf-interacted]')) || section.dataset.sfSubscribed === 'true' || section.dataset.sfAccount === 'true' || storage.get(requestedKey) === 'true' || Number(storage.get(dismissedKey)) > Date.now();
    if (dialog.dataset.sfHome !== 'true' || suppressed()) return;
    let activeMs = 0, activeSince = document.hidden ? null : performance.now();
    const visibleTime = () => activeMs + (activeSince === null ? 0 : performance.now() - activeSince);
    const check = () => {
      if (!dialog.isConnected || suppressed() || document.hidden || visibleTime() < 12000) return;
      const scroll = scrollMetrics();
      if (scroll.range <= 0 || scroll.top / scroll.range < .45) return;
      if (document.querySelector('dialog[open],.sf-mobile-menu[open]') || document.activeElement?.matches('input,textarea,select,button')) return;
      const book = document.getElementById('buch')?.getBoundingClientRect();
      if (book && book.top < window.innerHeight && book.bottom > 0) return;
      open();
    };
    document.addEventListener('scroll', check, {passive:true,capture:true});
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { if (activeSince !== null) activeMs += performance.now() - activeSince; activeSince = null; }
      else { activeSince = performance.now(); setTimeout(check, Math.max(0, 12000 - activeMs)); }
    });
    setTimeout(check, 12000);
  };
  const setupProductGallery = () => {
    const gallery = document.querySelector('[data-sf-inline-gallery]');
    if (!gallery || gallery.dataset.sfReady) return;
    gallery.dataset.sfReady = 'true';
    const track = gallery.querySelector('[data-sf-inline-track]');
    const slides = Array.from(track.querySelectorAll('[data-sf-inline-page]'));
    const counter = gallery.querySelector('[data-sf-inline-counter]');
    const dots = Array.from(gallery.querySelectorAll('[data-sf-inline-dot]'));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const firstClone = slides[0].cloneNode(true), lastClone = slides.at(-1).cloneNode(true);
    [firstClone,lastClone].forEach(clone => {
      clone.setAttribute('aria-hidden','true');
      clone.inert = true;
      clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
    });
    track.prepend(lastClone); track.append(firstClone);
    let current = 0, settleTimer, normalizingLoop = false;
    let snapRestoreFrame, originalSnap;
    const jump = physical => {
      if (snapRestoreFrame) cancelAnimationFrame(snapRestoreFrame);
      else originalSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollTo({left:physical*track.clientWidth,behavior:'instant'});
      snapRestoreFrame = requestAnimationFrame(() => {
        track.style.scrollSnapType = originalSnap;
        snapRestoreFrame = 0;
      });
    };
    const normalizeLoop = () => {
      if (normalizingLoop || drag) return;
      const width = Math.max(1,track.clientWidth);
      const physical = Math.round(track.scrollLeft / width);
      if (physical !== 0 && physical !== slides.length + 1) return;
      normalizingLoop = true;
      jump(physical === 0 ? slides.length : 1);
      requestAnimationFrame(() => { normalizingLoop = false; });
    };
    const update = () => {
      const width = Math.max(1,track.clientWidth);
      const physical = Math.min(slides.length + 1, Math.max(0, Math.round(track.scrollLeft / width)));
      current = (physical-1+slides.length)%slides.length;
      counter.textContent = `${current+1} / ${slides.length}`;
      dots.forEach((dot,index) => { if(index===current) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
      clearTimeout(settleTimer);
      if (track.scrollLeft < 1 || track.scrollLeft > (slides.length + 1) * width - 1) normalizeLoop();
      else settleTimer = setTimeout(normalizeLoop,70);
    };
    const show = (index,smooth=true) => {
      const target=(index+slides.length)%slides.length;
      let physical=target+1;
      if(smooth && current===slides.length-1 && index===slides.length) physical=slides.length+1;
      else if(smooth && current===0 && index===-1) physical=0;
      current=target;
      track.scrollTo({left:physical*track.clientWidth,behavior:smooth&&!reduced.matches?'smooth':'instant'});
    };
    track.addEventListener('scroll',update,{passive:true});
    track.addEventListener('scrollend',normalizeLoop);
    gallery.querySelector('[data-sf-inline-prev]').addEventListener('click',()=>show(current-1));
    gallery.querySelector('[data-sf-inline-next]').addEventListener('click',()=>show(current+1));
    dots.forEach((dot,index)=>dot.addEventListener('click',()=>show(index)));
    track.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1));}
    });
    jump(1);
    let trackWidth = track.clientWidth;
    new ResizeObserver(() => {
      const width = track.clientWidth;
      if (!width || width === trackWidth) return;
      trackWidth = width;
      jump(current + 1);
    }).observe(track);
    let drag = null, suppressClickUntil = 0;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, moved: false};
    });
    track.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      drag.deltaX = dx;
      if (!drag.moved) {
        if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
        drag.moved = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('sf-inline-dragging');
      }
      event.preventDefault();
      track.scrollLeft = drag.left - dx;
    });
    const release = () => {
      if (!drag) return;
      const state = drag;
      drag = null;
      track.classList.remove('sf-inline-dragging');
      if (track.hasPointerCapture(state.id)) track.releasePointerCapture(state.id);
      if (!state.moved) return;
      suppressClickUntil = performance.now() + 200;
      const delta = track.scrollLeft - state.left;
      const initial = Math.round(state.left / Math.max(1, track.clientWidth))-1;
      if (initial === slides.length - 1 && state.deltaX < -45) show(slides.length);
      else if (initial === 0 && state.deltaX > 45) show(-1);
      else show(initial + (Math.abs(delta) > 45 ? Math.sign(delta) : 0));
    };
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('lostpointercapture', release);
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => {
      if (event.detail && performance.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    const revealSample = event => {
      event?.preventDefault?.();
      show(1,false);
      gallery.scrollIntoView({block:'start',behavior:'instant'});
      document.dispatchEvent(new CustomEvent('sf:book-open',{detail:{index:1,readable:true,opener:event?.currentTarget}}));
    };
    document.querySelectorAll('[data-sf-gallery-open]').forEach(button => button.addEventListener('click', revealSample));
    document.querySelectorAll('[data-sf-gallery-reviews-open]').forEach(button => button.addEventListener('click',event => {
      event.preventDefault();
      event.stopPropagation();
      document.dispatchEvent(new CustomEvent('sf:book-open',{detail:{index:2,opener:button,reviewsOnly:true}}));
    }));
    const requested = new URL(window.location.href);
    if (requested.searchParams.get('leseprobe') === '1') {
      requested.searchParams.delete('leseprobe');
      requested.hash = 'sf-inline-book-gallery';
      window.history.replaceState(window.history.state, '', requested.pathname + requested.search + requested.hash);
      requestAnimationFrame(() => revealSample());
    }
    new ResizeObserver(() => show(current, false)).observe(track);
    update();
  };
  const setupBookZoom = () => {
    const dialog = document.querySelector('[data-sf-book-zoom]');
    if (!dialog || dialog.dataset.sfReady || typeof dialog.showModal !== 'function') return;
    dialog.dataset.sfReady = 'true';
    const figures = Array.from(dialog.querySelectorAll('[data-sf-zoom-media]')).sort((a,b) => Number(a.dataset.sfZoomMedia)-Number(b.dataset.sfZoomMedia));
    const viewport = dialog.querySelector('[data-sf-zoom-viewport]');
    const title = dialog.querySelector('[data-sf-zoom-title]');
    const toggle = dialog.querySelector('[data-sf-zoom-toggle]');
    const counter = dialog.querySelector('[data-sf-zoom-counter]');
    let opener = null, current = 0, excerptMode = 0, keyboard = false, start = null, backdropBlockedUntil = 0, reviewsOnly = false;
    const setZoom = (enlarged,readable=false) => {
      const excerpt = figures[current]?.querySelector('[data-sf-excerpt-reader]');
      excerptMode = excerpt ? (enlarged ? 2 : readable ? 1 : 0) : 0;
      dialog.dataset.sfExcerptMode = excerpt ? ['page','reading','large'][excerptMode] : '';
      const reading = Boolean(excerpt && excerptMode > 0);
      dialog.classList.toggle('sf-excerpt-readable',reading);
      dialog.classList.toggle('sf-excerpt-extra',Boolean(excerpt && enlarged));
      figures.forEach(figure => { const reader = figure.querySelector('[data-sf-excerpt-reader]'); if (reader) reader.hidden = !reading || figure !== figures[current]; });
      const activeImage=figures[current]?.querySelector('img');
      if (enlarged && activeImage && !excerpt) {
        const fittedWidth=activeImage.getBoundingClientRect().width;
        const width=Math.min(viewport.clientWidth-32,fittedWidth*(current === 1 ? (window.matchMedia('(min-width:1000px)').matches ? 1.62 : 1.44) : 1.18));
        dialog.style.setProperty('--sf-zoom-image-width', `${Math.max(1,width)}px`);
      }
      dialog.classList.toggle('sf-book-zoom-enlarged', enlarged);
      toggle.setAttribute('aria-pressed', String(enlarged));
      toggle.textContent = enlarged ? toggle.dataset.fitLabel : toggle.dataset.enlargeLabel;
      viewport.scrollTo({top:0,left:0,behavior:'instant'});
    };
    const show = index => {
      if (reviewsOnly && index !== 2) return;
      const imageCount = figures.length;
      current = reviewsOnly ? 2 : ((index % imageCount) + imageCount) % imageCount;
      figures.forEach((figure,i) => { figure.hidden = i !== current; });
      title.textContent = figures[current].dataset.sfZoomTitle;
      counter.textContent = reviewsOnly ? 'Rezensionen' : `${current+1} / ${figures.length}`;
      toggle.hidden = figures[current].dataset.sfZoomMedia === '2';
      // The lower close button was removed in favor of the purchase action.
      dialog.querySelector('.sf-zoom-navigation').hidden = reviewsOnly;
      setZoom(false);
    };
    document.querySelectorAll('[data-sf-zoom-open]').forEach(button => button.addEventListener('click', event => {
      const index = figures.findIndex(figure => figure.dataset.sfZoomMedia === button.dataset.sfZoomOpen);
      if (index < 0) return;
      opener = button; keyboard = event.detail === 0;
      reviewsOnly = false;
      show(index); if (!dialog.open) dialog.showModal(); document.body.classList.add('sf-modal-open');
      if (figures[index].dataset.sfZoomMedia === '1') setZoom(false,false);
    }));
    document.addEventListener('sf:book-open',event => {
      const index = figures.findIndex(figure => Number(figure.dataset.sfZoomMedia) === event.detail.index);
      if (index < 0) return;
      opener = event.detail.opener || document.activeElement;
      keyboard = false;
      reviewsOnly = Boolean(event.detail.reviewsOnly);
      backdropBlockedUntil = performance.now() + 350;
      show(index);
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('sf-modal-open');
      if (event.detail.readable) setZoom(false,true);
    });
    toggle.addEventListener('click', () => {
      if (figures[current]?.querySelector('[data-sf-excerpt-reader]')) {
        const nextMode = (excerptMode + 1) % 3;
        setZoom(nextMode === 2,nextMode === 1);
      } else setZoom(!dialog.classList.contains('sf-book-zoom-enlarged'));
    });
    dialog.querySelector('[data-sf-zoom-prev]').addEventListener('click', () => show(current-1));
    dialog.querySelector('[data-sf-zoom-next]').addEventListener('click', () => show(current+1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(current+(event.key === 'ArrowRight' ? 1 : -1)); }
    });
    // Trackpad two-finger wheel scrolling is forwarded to the enlarged book's
    // internal viewport. Normal gallery interactions remain unchanged.
    viewport.addEventListener('wheel', event => {
      if (!dialog.open || !dialog.classList.contains('sf-book-zoom-enlarged') || event.ctrlKey) return;
      const scrollableY = viewport.scrollHeight > viewport.clientHeight + 2;
      const scrollableX = viewport.scrollWidth > viewport.clientWidth + 2;
      if (!scrollableX && !scrollableY) return;
      event.preventDefault();
      event.stopPropagation();
      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.clientHeight : 1;
      if (scrollableY) viewport.scrollTop += event.deltaY * unit;
      if (scrollableX) viewport.scrollLeft += event.deltaX * unit;
    }, {passive:false});
    viewport.addEventListener('touchstart', event => {
      start = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
    }, {passive:true});
    viewport.addEventListener('touchend', event => {
      if (!start) return;
      const touch=event.changedTouches[0], dx=touch.clientX-start.x, dy=touch.clientY-start.y;
      if (Math.abs(dx)+Math.abs(dy)>12) backdropBlockedUntil=performance.now()+400;
      if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.3) show(current+(dx<0 ? 1 : -1));
      start=null;
    }, {passive:true});
    viewport.addEventListener('click', event => {
      if (!window.matchMedia('(pointer:fine)').matches || event.target.tagName !== 'IMG' || performance.now()<backdropBlockedUntil) return;
      const bounds=event.target.getBoundingClientRect();
      show(current+(event.clientX<bounds.left+bounds.width/2?-1:1));
      backdropBlockedUntil=performance.now()+300;
    });
    dialog.querySelectorAll('[data-sf-zoom-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (performance.now()<backdropBlockedUntil) return;
      if (!event.target.closest('img,button,a,.sf-gallery-reviews,.sf-excerpt-reader')) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('sf-modal-open');
      if (keyboard) opener?.focus({preventScroll:true}); else document.activeElement?.blur();
    });
  };
  const setupContactValidation = () => {
    const form = document.querySelector('[data-sf-contact]');
    if (!form || form.dataset.sfReady) return;
    form.dataset.sfReady = 'true';
    form.noValidate = true;
    const fields = [
      {field:form.querySelector('[name="contact[name]"]'), message:form.dataset.sfNameError, valid:value => Array.from(value.replace(/\s/gu, '')).length >= 2},
      {field:form.querySelector('[name="contact[email]"]'), message:form.dataset.sfEmailError, valid:value => /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)*\.[^\s@.]{2,}$/u.test(value)},
      {field:form.querySelector('[name="contact[body]"]'), message:form.dataset.sfBodyError, valid:value => Array.from(value).length >= 10}
    ];
    const validate = ({field, message, valid}) => {
      field.value = field.value.trim();
      const correct = valid(field.value);
      const error = document.getElementById(field.getAttribute('aria-describedby'));
      field.setAttribute('aria-invalid', String(!correct));
      if (error) { error.textContent = correct ? '' : message; error.hidden = correct; }
      return correct;
    };
    fields.forEach(item => {
      item.field.addEventListener('blur', () => validate(item));
      item.field.addEventListener('input', () => { if (item.field.getAttribute('aria-invalid') === 'true') validate(item); });
    });
    form.addEventListener('submit', event => {
      const invalid = fields.filter(item => !validate(item));
      if (invalid.length || form.dataset.sfSubmitting) { event.preventDefault(); invalid[0]?.field.focus(); return; }
      form.dataset.sfSubmitting = 'true';
      form.querySelector('[type=submit]').disabled = true;
      form.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => { delete form.dataset.sfSubmitting; form.removeAttribute('aria-busy'); form.querySelector('[type=submit]').disabled = false; });
  };
  const setupGenericProduct = () => {
    const form = document.querySelector('[data-sf-generic-product]');
    const select = form?.querySelector('[data-sf-variant]');
    if (!select || form.dataset.sfVariantReady) return;
    form.dataset.sfVariantReady = 'true';
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const button = form.querySelector('[type=submit]');
      const quantity = form.querySelector('[name=quantity]');
      form.querySelector('[data-sf-variant-price]').textContent = option.dataset.price;
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.unavailable : button.dataset.label;
      quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      const sticky = document.querySelector('#sf-sticky-product-form [name=id]');
      if (sticky) sticky.value = option.value;
    });
  };
  const setupDisclosures = () => {
    const running = new WeakMap();
    const change = (item, expanded) => {
      const summary = item.querySelector(':scope > summary');
      const isMenu = item.classList.contains('sf-mobile-menu');
      const panel = isMenu ? item.querySelector(':scope > nav') : item;
      const from = item.open ? panel.getBoundingClientRect().height : (isMenu ? 0 : item.getBoundingClientRect().height);
      const currentPadding = getComputedStyle(panel);
      const fromPadding = [currentPadding.paddingTop, currentPadding.paddingBottom];
      const previous = running.get(item);
      const overflow = previous ? previous.overflow : panel.style.overflow;
      if (previous) { previous.animation.oncancel = null; previous.animation.cancel(); }
      panel.style.overflow = overflow;
      running.delete(item);
      item.dataset.sfExpanded = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof panel.animate !== 'function') {
        item.open = expanded;
        return;
      }
      item.open = true;
      const naturalHeight = panel.getBoundingClientRect().height;
      const style = getComputedStyle(panel);
      const collapsedHeight = summary.getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const to = expanded ? naturalHeight : (isMenu ? 0 : collapsedHeight);
      panel.style.overflow = 'hidden';
      const first = {height: `${from}px`};
      const last = {height: `${to}px`};
      if (isMenu) {
        first.paddingTop = from === 0 ? '0px' : fromPadding[0];
        first.paddingBottom = from === 0 ? '0px' : fromPadding[1];
        last.paddingTop = expanded ? style.paddingTop : '0px';
        last.paddingBottom = expanded ? style.paddingBottom : '0px';
      }
      const animation = panel.animate([first, last], {duration: isMenu ? 300 : 340, easing: 'cubic-bezier(.22,.61,.36,1)'});
      running.set(item, {animation, overflow});
      const restore = () => { panel.style.overflow = overflow; };
      animation.oncancel = restore;
      animation.onfinish = () => {
        if (running.get(item)?.animation !== animation) return;
        item.open = expanded;
        restore();
        running.delete(item);
      };
    };
    document.querySelectorAll('.sf-mobile-menu,.sf-book-more,.sf-brands-details,.sf-faq-items details').forEach(item => {
      if (item.dataset.sfDisclosureReady) return;
      item.dataset.sfDisclosureReady = 'true';
      item.dataset.sfExpanded = String(item.open);
      const summary = item.querySelector(':scope > summary');
      summary.setAttribute('aria-expanded', String(item.open));
      item.addEventListener('toggle', () => {
        if (running.has(item)) return;
        item.dataset.sfExpanded = String(item.open);
        summary.setAttribute('aria-expanded', String(item.open));
      });
      summary.addEventListener('click', event => {
        event.preventDefault();
        const expanded = item.dataset.sfExpanded !== 'true';
        const faq = item.closest('.sf-faq-items');
        if (expanded && faq) faq.querySelectorAll('details').forEach(other => {
          if (other !== item && other.dataset.sfExpanded === 'true') change(other, false);
        });
        change(item, expanded);
      });
      if (item.classList.contains('sf-mobile-menu')) {
        item.querySelectorAll('a').forEach(link => link.addEventListener('click', () => change(item, false)));
        item.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          change(item, false);
          summary.focus();
        });
      }
    });
  };
  let discountFocusReady = false;
  const setupDiscountFocus = () => {
    if (discountFocusReady) return;
    discountFocusReady = true;
    document.addEventListener('keydown', event => {
      const input = event.target.closest?.('[data-sf-discount-input]');
      if (!input || event.key !== 'Enter') return;
      event.preventDefault();
      const apply = input.closest('[data-sf-discount]')?.querySelector('[data-sf-discount-apply]');
      if (apply && !apply.disabled) apply.click();
    });
  };
  const mount = () => {
    setupDiscountFocus();
    setupNewsletterForms();
    setupReviews();
    setupDigitalpost();
    setupProductGallery();
    setupBookZoom();
    setupContactValidation();
    setupGenericProduct();
    if (window.location.hash === '#kontakt') { const details = document.getElementById('sf-brand-details'); if (details) details.open = true; }
    document.querySelectorAll('[data-sf-today]').forEach(node => {
      node.textContent = new Intl.DateTimeFormat('de-DE', {day:'2-digit',month:'2-digit',year:'numeric',timeZone:'Europe/Berlin'}).format(new Date());
    });
    setupPrivacyAppearance();
    setupCartPanel();
    setupAnnouncements();
    setupReveals();
    setupDisclosures();
    document.querySelectorAll('[data-sf-copy-email]').forEach(button => {
      if (button.dataset.sfReady) return;
      button.dataset.sfReady = 'true';
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText('sheriffadel.mgm@gmail.com');
          button.nextElementSibling.textContent = button.dataset.copiedLabel;
        } catch {
          const address = document.querySelector('.sf-email-address');
          if (address) {
            const range = document.createRange();
            range.selectNodeContents(address);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }
      });
    });
    document.querySelectorAll('[data-sf-reach]').forEach(grid => {
      if(grid.dataset.sfReady)return;
      grid.dataset.sfReady='true';
      const cards=Array.from(grid.querySelectorAll('article'));
      const replay=grid.closest('.sf-reach')?.querySelector('[data-sf-replay]');
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(reduced||!('IntersectionObserver' in window))return;
      const runs=new Map();
      const formatter=new Intl.NumberFormat('de-DE',{maximumFractionDigits:0});
      const animateCard=card=>{
        const number=card.querySelector('[data-sf-count]');
        if(!number)return;
        const run=(runs.get(card)||0)+1;runs.set(card,run);
        card.classList.remove('sf-count-pending');
        card.dataset.sfCountPlayed='true';
        const target=Number(number.dataset.sfCount);
        const began=performance.now();
        number.classList.add('sf-count-expanded');
        number.textContent='0';
        const tick=now=>{
          if(!number.isConnected||runs.get(card)!==run)return;
          const progress=Math.min(1,(now-began)/6000);
          number.textContent=formatter.format(Math.floor(target*(1-Math.pow(1-progress,1.2))));
          if(progress<1)requestAnimationFrame(tick);
          else{
            number.textContent=number.dataset.finalLabel||formatter.format(target);
            number.classList.remove('sf-count-expanded');
            if(replay)replay.hidden=false;
          }
        };
        requestAnimationFrame(tick);
      };
      const observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(!entry.isIntersecting||entry.intersectionRatio<0.5)return;
          observer.unobserve(entry.target);animateCard(entry.target);
        });
      },{threshold:0.5,rootMargin:'0px 0px -16px 0px'});
      cards.forEach(card=>{card.classList.add('sf-count-pending');observer.observe(card);});
      replay?.addEventListener('click',()=>{
        cards.forEach(card=>{card.dataset.sfCountPlayed='false';observer.observe(card);});
      });
      document.addEventListener('shopify:section:unload',()=>{if(!grid.isConnected)observer.disconnect();},{once:true});
    });
    document.querySelectorAll('[data-sf-sale]').forEach(sale => {
      if (sale.dataset.sfReady) return;
      sale.dataset.sfReady = 'true';
      const validZone = value => /(Z|[+-]\d{2}:\d{2})$/i.test(value || '');
      if (!validZone(sale.dataset.start) || !validZone(sale.dataset.end)) return;
      const start = Date.parse(sale.dataset.start);
      const end = Date.parse(sale.dataset.end);
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
      const date = sale.querySelector('[data-sf-sale-date]');
      if (date) date.textContent = new Intl.DateTimeFormat('de-DE', {dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Berlin'}).format(new Date(end)) + ' (Berlin)';
      let timer;
      const update = () => {
        const now = Date.now();
        if (!sale.isConnected || now >= end) {
          sale.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        sale.hidden = now < start;
        if (sale.hidden) return;
        const remaining = Math.max(0, Math.floor((end - now) / 1000));
        const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
        Object.entries(values).forEach(([key, value]) => {
          const field = sale.querySelector(`[data-sf-${key}]`);
          if (field) field.textContent = String(value).padStart(2, '0');
        });
      };
      if (Date.now() < end) timer = setInterval(update, 1000);
      update();
    });
    const bar = document.querySelector('[data-sf-buybar]');
    if (bar && !bar.dataset.sfReady) {
      bar.dataset.sfReady = 'true';
      const book = document.querySelector('#buch');
      const purchase = document.querySelector('[data-sf-direct-purchase]') || document.querySelector('#sf-product-form');
      const contact = document.querySelector('#SherifBrandContact');
      const newsletter = document.querySelector('.sf-footer-newsletter');
      const footer = newsletter?.closest('.sf-footer');
      const home = Boolean(document.querySelector('.sf-home'));
      const phone = window.matchMedia('(max-width: 749px) and (pointer: coarse)');
      let primaryVisible = false;
      let contactVisible = false;
      let newsletterVisible = false;
      const update = () => {
        const anchor = purchase || book;
        const pastAnchor = anchor ? anchor.getBoundingClientRect().bottom < 0 : scrollMetrics().top > 450;
        const mobileHome = home && phone.matches;
        const nearFooter = mobileHome && footer && footer.getBoundingClientRect().top < window.innerHeight;
        const show = pastAnchor && !primaryVisible && !contactVisible && !newsletterVisible && !nearFooter;
        if (bar.hidden === show) bar.hidden = !show;
        document.body.classList.toggle('sf-buybar-active', show && !mobileHome);
      };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === (purchase || book)) primaryVisible = entry.isIntersecting;
          if (entry.target === contact) contactVisible = entry.isIntersecting;
          if (entry.target === newsletter) newsletterVisible = entry.isIntersecting;
        });
        update();
      }, {threshold: 0});
      if (purchase || book) observer.observe(purchase || book);
      if (contact) observer.observe(contact);
      if (newsletter) observer.observe(newsletter);
      document.addEventListener('scroll', update, {passive: true, capture: true});
      window.addEventListener('resize', update, {passive: true});
      update();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();




document.addEventListener('click', async event => {
  const button = event.target.closest?.('[data-sf-discount-apply]');
  if (!button || button.disabled) return;
  const block = button.closest('[data-sf-discount]');
  const input = block.querySelector('[data-sf-discount-input]');
  const status = block.querySelector('[data-sf-discount-status]');
  const code = input.value.trim();
  if (!code) { status.textContent = block.dataset.empty; input.focus(); return; }
  const dialog = block.closest('[data-sf-cart-dialog]');
  const cartPage = block.closest('.sf-cart-page');
  const directPurchase = block.closest('[data-sf-direct-purchase]');
  const scope = dialog || cartPage || directPurchase;
  const checkoutButtons = Array.from(scope?.querySelectorAll('[name="checkout"],button[type="submit"]') || []);
  const disabledStates = checkoutButtons.map(node => ({node,disabled:node.disabled}));
  button.disabled = true; input.readOnly = true; block.dataset.sfDiscountBusy = 'true';
  disabledStates.forEach(({node}) => { node.disabled = true; });
  status.textContent = block.dataset.checking;
  let visibleStatus = status;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const currentResponse = await fetch(root + 'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
    if (!currentResponse.ok) throw new Error('cart');
    let current = await currentResponse.json();
    if (directPurchase && !current.items.some(item => String(item.variant_id) === directPurchase.dataset.variantId)) {
      const added = await fetch(root + 'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(directPurchase.dataset.variantId),quantity:1}]})});
      if (!added.ok) throw new Error('cart');
    }
    const codes = (current.discount_codes || []).filter(item => item.applicable !== false).map(item => item.code).filter(Boolean);
    if (!codes.some(item => item.toLowerCase() === code.toLowerCase())) codes.push(code);
    const pageSection = cartPage?.closest('.shopify-section')?.id?.replace(/^shopify-section-/,'');
    const sections = directPurchase ? [] : ['sherif-cart-panel',pageSection].filter(Boolean);
    const response = await fetch(root + 'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(','),sections,sections_url:window.location.pathname})});
    if (!response.ok) throw new Error('discount');
    const cart = await response.json();
    const applied = (cart.discount_codes || []).find(item => item.code.toLowerCase() === code.toLowerCase());
    if (!applied?.applicable) { status.textContent = block.dataset.invalid; return; }
    if (directPurchase) { status.textContent = block.dataset.success; return; }
    const preserve = Array.from(scope.querySelectorAll('[data-sf-digital-consent]')).map(node => ({id:node.id,checked:node.checked,value:node.value}));
    let html = dialog ? cart.sections?.['sherif-cart-panel'] : cart.sections?.[pageSection];
    if (!html) {
      const url = new URL(window.location.pathname,window.location.origin);
      url.searchParams.set('section_id',dialog ? 'sherif-cart-panel' : pageSection);
      const rendered = await fetch(url,{credentials:'same-origin'});
      if (rendered.ok) html = await rendered.text();
    }
    if (!html) { status.textContent = block.dataset.updated; return; }
    const doc = new DOMParser().parseFromString(html,'text/html');
    const target = dialog ? dialog.querySelector('.sf-cart-panel') : cartPage;
    const fresh = doc.querySelector(dialog ? '.sf-cart-panel' : '.sf-cart-page');
    if (!fresh) { status.textContent = block.dataset.updated; return; }
    document.dispatchEvent(new CustomEvent('sf:cart-before-render'));
    target.innerHTML = fresh.innerHTML;
    preserve.forEach(saved => { const node = document.getElementById(saved.id); if (node && node.value === saved.value) node.checked = saved.checked; });
    document.querySelectorAll('.sf-cart-count').forEach(node => { node.textContent = String(cart.item_count); });
    const activeBlock = scope.querySelector('[data-sf-discount]');
    if (activeBlock) {
      activeBlock.open = true;
      activeBlock.querySelector('[data-sf-discount-input]').value = code;
      visibleStatus = activeBlock.querySelector('[data-sf-discount-status]');
      visibleStatus.textContent = block.dataset.success;
      activeBlock.querySelector('[data-sf-discount-apply]').focus({preventScroll:true});
    }
  } catch { visibleStatus.textContent = block.dataset.error; }
  finally {
    delete block.dataset.sfDiscountBusy;
    button.disabled = false; input.readOnly = false;
    disabledStates.forEach(({node,disabled}) => { if (node.isConnected) node.disabled = disabled; });
  }
});









